/** biome-ignore-all lint/style/noNestedTernary: no nested ternary */
/** biome-ignore-all lint/suspicious/noArrayIndexKey: dont use index as key */
/** biome-ignore-all lint/style/useNamingConvention: allow snake case */
import {useSelector} from 'react-redux';
import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';
import {isFabric} from '~/common/utils/event_utils';
import {selectOrigin} from '~/ViewInvitation/selectors/eventDetails';
import {DesignTemplateNew} from './Invitation/DesignTemplateNew';
import {DesignTemplateOld} from './Invitation/DesignTemplateOld';

export const DesignTemplate = ({
  adsPageType,
  googleAdsKey,
  isWebview = false,
  isViewInvitationPage = true,
  scrollToPhotos = false,
  showPremiumWebview = undefined, // Needed for DesignTemplate to behave when referenced in TypeScript
  animated = true,
  onCanPlayAnimation = () => undefined,
  toggleUpsellModal = () => undefined,
  setAnimationComplete = () => undefined,
}) => {
  const isPremium = useSelector(
    (state) =>
      state.eventDetails.isPremium ||
      state.user.subscriptionPlanName === PLAN_NAME_PRO ||
      state.user.subscriptionPlanName === PLAN_NAME_PARTY_PASS
  );
  const origin = useSelector(selectOrigin);
  const isFabricEvent = isFabric(origin);
  const showLatestDesign = isViewInvitationPage && isFabricEvent && isPremium;

  // DesignTemplateNew - all events post 2022 (shows 2025 animation)
  // DesignTemplateOld - all events pre 2023 (shows one of the older versions depending on event date)
  return showLatestDesign ? (
    <DesignTemplateNew
      {...{
        adsPageType,
        googleAdsKey,
        isWebview,
        isViewInvitationPage,
        scrollToPhotos,
        showPremiumWebview,
        isPremium,
        onCanPlayAnimation,
        toggleUpsellModal,
        setAnimationComplete,
      }}
    />
  ) : (
    <DesignTemplateOld
      {...{
        adsPageType,
        googleAdsKey,
        isWebview,
        isViewInvitationPage,
        showPremiumWebview,
        isPremium,
        onCanPlayAnimation,
        toggleUpsellModal,
        animated,
        isFabricEvent,
      }}
    />
  );
};
